import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import FormSection from "@my-dld/components/Form/FormSection";
import Dropzone from "react-dropzone";
import DocumentInputField from "@my-dld/components/Form/DocumentInputField";
import { RVSDocTypes } from "@my-dld/utils/RVSUtils";
import { PSDocument } from "../../../apis/privatesell/enitites";
import { StringUtil } from "@eres/core";
import { formatAppDate, openDocument } from "@my-dld/utils/Utils";
import { isEmptyStringOrNull } from "@eres/core/dist/StringUtils";
import { FormContainer, IPrivateSellForm, IPrivateSellFormProps, IPrivateSellFormState, ShowFormOnlyIf, ShowOnlyIf } from "./Base";
import { getMaxPageSize, getMaxPropertyImageCount } from "../../../apis/privatesell/api";

interface Props extends IPrivateSellFormProps {
	documents?: PSDocument[];
}

interface State extends IPrivateSellFormState {
	errorMsg?: string;
	error: any;
	documents: PSDocument[] | undefined;
	docsError?: any;
}

export default class PropertyPhotos extends Component<Props, State> implements IPrivateSellForm<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			isValid: false,
			error: {},
			documents: props.documents,
		};
	}

	isValid = ( _isUserAction?: boolean ) => {
		return true;
	};
	getData = ( state: State = this.state ) => {
		return {
			documents: state?.documents,
		};
	};


	render() {
		const { readonly, documents } = this.props;
		const Container = readonly ? FormContainer : FormSection;
		const countDocument = getMaxPropertyImageCount() ?? 10;
		const maxSizeKb = getMaxPageSize() ? ( getMaxPageSize() * 1000 ) : ( 2 * 1024 * 1000 );
		const editMode = documents && documents.length > 0 ? true : false;
		return <ShowFormOnlyIf id={ "documents" } holder={ this } readonly={ readonly }>
			<div className="tender-registration-form">
				<Container title={ Strings.property_photos }>
					<ShowOnlyIf valid={ !readonly }>
						<div className="mandatory-field-info">
							<small>{ Strings.mandatory_fields_note }</small>
						</div>
					</ShowOnlyIf>
					{ this.state.errorMsg && <div className="alert alert-danger">{ this.state.errorMsg }</div> }
					<div className={ "row" }>
						<ShowOnlyIf valid={ !readonly && ( this.state.documents && this.state.documents.length < countDocument ) === true }>
							<div className="col-4">
								<Dropzone
									multiple={ true }
									maxSize={ maxSizeKb }
									onDropRejected={ this.onDropRejected }
									onDrop={ this.onDrop }
									accept={ [ "image/png", "image/jpeg", "application/pdf" ] }>
									{ ( { getRootProps, getInputProps } ) => (
										<DocumentInputField { ...getRootProps() }
										                    dropZoneInputProps={ getInputProps() }
										                    label={ "" }/>
									) }
								</Dropzone>
							</div>
						</ShowOnlyIf>
						{
							this.state.documents && this.state.documents.length > 0 &&
							<div className="col-12">
								<div className={ "mb-2 table-responsive" }>
									<table className="table table-bordered table-condensed table-striped table-responsive-sm upload-table">
										<thead>
										<tr>
											<th>{ Strings.file }</th>
											<th>{ Strings.name }</th>
											{
												!readonly &&
												<>
													{
														!editMode && <>
															<th>{ Strings.size }</th>
															<th>{ Strings.vid_date }</th>
														</>
													}
													<th>{ Strings.action }</th>
												</>
											}
										</tr>
										</thead>
										<tbody>
										{ this.state.documents.map( ( doc: PSDocument, index: number ) => {
											return <RenderPSUploadDoc
												key={ "rvs_doc_" + index } doc={ doc } readonly={ readonly } editMode={ editMode }
												onDelete={ () => this.onDelete( index ) }/>;
										} ) }
										</tbody>
									</table>
								</div>
							</div>
						}
					</div>
				</Container>
			</div>
		</ShowFormOnlyIf>;
	}

	public reset() {
		this.setState( {
			documents: [],
			errorMsg: undefined,
		} );
	}

	private onDropRejected = () => {
		this.setState( {
			errorMsg: Strings.tabu_file_exceed_size,
		} );
	};

	private onDrop = ( files: File[] ) => {
		const countDocument = getMaxPropertyImageCount() ?? 10;
		if ( files.length > countDocument ) {
			this.setState( {
				errorMsg: Strings.file_page_exceed.replace( "~", countDocument + "" ),
			} );
			return;
		}
		files.filter( x => x.type.startsWith( "image/" ) || x.type.startsWith( "application/pdf" ) )
		.forEach( file => this.addFile( file ) );
	};

	private onDelete = ( index: any ) => {
		const { documents } = this.state;
		if ( documents && documents.length > 0 ) {
			documents.splice( index, 1 );
			this.setState( {
				documents: documents,
			} );
		}
	};

	private addFile( file: File ) {
		const reader = new FileReader();
		reader.onload = () => {
			const binaryStr = reader.result;
			const attachedDoc: PSDocument = {
				identity: 4,
				localFile: file,
				localData: binaryStr as string,
				fileName: file.name,
				fileSize: file.size,
				type: file.type,
				documentType: {
					identity: 4,
					nameAr: "PropertyImages",
					nameEn: "PropertyImages",
					parentId: 0,
				},
			};
			this.setState( {
				errorMsg: undefined,
				documents: this.state.documents ? this.state.documents.concat( attachedDoc ) : [ attachedDoc ],
			} );
		};
		reader.readAsDataURL( file );
	}
}

function RenderPSUploadDoc( props: { doc: PSDocument, readonly: boolean, editMode: boolean, onDelete: () => void } ) {
	const { doc, readonly, onDelete, editMode } = props;
	let docType = getPSDocType( doc );
	let preview = ( docType === RVSDocTypes.PDF ) ? <i className="far fa-file-pdf"/> : getImagePreview( doc );
	return <tr>
		<td data-label={ Strings.file }>{ preview }</td>
		<td><a
			key={ `ps_req_doc_${ doc.identity }` }
			onClick={ () => {
				if ( doc.remoteDoc ) {
					const url = doc.remoteDoc.url.replace( /\\/g, "/" );
					openDocument( url, doc.remoteDoc.documentType.nameEn! );
				} else {
				}
			} }>
			<i/>{ getPSDocName( doc ) }</a></td>
		{
			!readonly &&
			<>
				{
					!editMode && <>
						<td data-label={ Strings.size }>{ getPSDocSize( doc ) + " " + Strings.size_mb }</td>
						<td data-label={ Strings.vid_date }>{ getPSDocDate( doc ) }</td>
					</>
				}
				<td>
					<button className="btn btn-grey" onClick={ onDelete }>
						<i className="far fa-trash-alt"/>{ Strings.delete }
					</button>
				</td>
			</>
		}
	</tr>;
}

export function getPSDocType( doc: PSDocument ) {
	let type = RVSDocTypes.PDF;
	let localData = doc.localData;
	let remoteDoc = doc.remoteDoc;
	if ( remoteDoc && !StringUtil.isEmptyStringOrNull( remoteDoc.url ) ) {
		let fileUrl = remoteDoc.url.toLocaleLowerCase();
		if ( fileUrl.endsWith( ".png" ) || fileUrl.endsWith( ".jpg" ) )
			type = RVSDocTypes.IMAGE;
	} else if ( localData && !StringUtil.isEmptyStringOrNull( localData ) ) {
		const d = localData.split( ";" )[ 0 ];
		if ( d.includes( "image" ) )
			type = RVSDocTypes.IMAGE;
	}
	return type;
}

export function getPSDocName( doc: PSDocument ) {
	let fileUrl = doc.remoteDoc ? doc.remoteDoc.url : "";
	if ( fileUrl && !StringUtil.isEmptyStringOrNull( fileUrl ) )
		return fileUrl.substring( fileUrl.lastIndexOf( "/" ) + 1, fileUrl.length );
	return doc.fileName;
}

export function getPSDocSize( doc: PSDocument ) {
	let size = doc.fileSize;
	if ( size && size > 0 ) {
		return parseFloat( "" + ( size / ( 1024 * 1024 ) ) ).toFixed( 2 );
	}
	return "";
}

export function getPSDocDate( doc: PSDocument ) {
	let localData = doc.localData;
	if ( localData && !StringUtil.isEmptyStringOrNull( localData ) ) {
		return formatAppDate( new Date(), "en" );
	}
	return "";
}

export function getImagePreview( doc: PSDocument ) {
	let source = ( doc.localData && !isEmptyStringOrNull( doc.localData ) ) ?
		doc.localData : ( ( doc.remoteDoc && !isEmptyStringOrNull( doc.remoteDoc.url ) ) ?
			doc.remoteDoc.url : "" );
	return <img src={ source } style={ { height: 40, width: 40 } } alt={ "uploaded_image" }/>;
}


